import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=0cc9c47b&scoped=true"
import script from "./user-list.vue?vue&type=script&lang=js"
export * from "./user-list.vue?vue&type=script&lang=js"
import style0 from "./user-list.vue?vue&type=style&index=0&id=0cc9c47b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc9c47b",
  null
  
)

export default component.exports